import { categoryDirectory, categoryQuotation, companyAccount, quoteRequest, userAccount, landing, landingSupplier } from 'routes'
// import iconEnvelope from 'icon/win10/envelope.svg?component'
// import iconHousekeeper from 'icon/win10/housekeeper.svg?component'
import iconHousehold from 'icon/win10/household.svg?component'
import iconAdressMap from 'icon/win10/address-map.svg?component'
import iconClipboardAdd from 'icon/win10/shopping-basket.svg?component'
import iconClipboardCheck from 'icon/win10/clipboard-check.svg?component'
import iconCommercial from 'icon/win10/commercial.svg?component'
import iconHeart from 'icon/win10/heart.svg?component'
import iconHome from 'icon/win10/home.svg?component'
import iconIdentification from 'icon/win10/identification.svg?component'
import iconKey from 'icon/win10/key.svg?component'
import iconMoney3 from 'icon/win10/money-3.svg?component'
import iconStarOutline from 'icon/win10/star-outline.svg?component'
import iconUserAccount from 'icon/win10/user-account.svg?component'
import iconCabinet from 'icon/win10/cabinet.svg?component'


export const mainMenu = {
  shared: [{
    type: 'link',
    name: 'Início',
    icon: iconHome,
    url: landing.index,
    selected: [landing.index]
  }]
}

export const userMenu = {
  shared: [
    {
      type: 'link',
      name: 'Avaliações',
      icon: iconStarOutline,
      url: userAccount.review,
      selected: [userAccount.review]
    },
    {
      type: 'link',
      name: 'Dados pessoais',
      icon: iconIdentification,
      url: userAccount.account,
      selected: [userAccount.account]
    },
    // {
    //   type: 'link',
    //   name: 'Privacidade',
    //   icon: iconEnvelope,
    //   url: userAccount.privacy,
    //   selected: [ userAccount.privacy ]
    // },
    {
      type: 'link',
      name: 'Segurança',
      icon: iconKey,
      url: userAccount.changePassword,
      selected: [userAccount.changePassword]
    },
    {
      type: 'link',
      name: 'Endereços',
      icon: iconAdressMap,
      url: userAccount.address,
      selected: [userAccount.address]
    },
    {
      type: 'link',
      name: 'Fornecedores favoritos',
      icon: iconHeart,
      url: userAccount.favorite,
      selected: [userAccount.favorite]
    },
    {
      type: 'link',
      name: 'Seja um fornecedor',
      icon: iconCommercial,
      url: landingSupplier.plans,
      selected: [landingSupplier.plans]
    },
  ],

  companyHeader: [{
    type: 'link',
    name: 'Minhas cotações',
    icon: iconClipboardCheck,
    url: quoteRequest.index,
    selected: [quoteRequest.index]
  }],

  companyMobile: [{
    type: 'action',
    name: 'Guia de fornecedores',
    icon: iconClipboardAdd,
    action: (self) => self.$store.dispatch('navigation/openMenu', 'category'),
    selected: [categoryQuotation.index, categoryDirectory.index]
  }]
}

export const companyMenu = {
  shared: [{
    type: 'link',
    name: 'Avaliações',
    icon: iconStarOutline,
    url: companyAccount.review,
    selected: [companyAccount.review]
  }, {
    type: 'link',
    name: 'Endereços profissionais',
    icon: iconHousehold,
    url: companyAccount.building,
    selected: [companyAccount.building]
  }, {
    type: 'link',
    name: 'Usuários da empresa',
    icon: iconUserAccount,
    url: companyAccount.userList,
    selected: [companyAccount.userList, companyAccount.userAdd]
  }, {
    type: 'submenu',
    name: 'Anúncio',
    icon: iconCommercial,
    submenu: [{
      type: 'link',
      name: 'Perfil público',
      icon: null,
      url: companyAccount.account,
      selected: [companyAccount.account],
    }, {
      type: 'link',
      name: 'Especialidades anunciadas',
      icon: null,
      url: companyAccount.category,
      selected: [companyAccount.category],
    }, {
      type: 'link',
      name: 'Área de atendimento',
      icon: null,
      url: companyAccount.location,
      selected: [companyAccount.location],
    }],
  }, {
    name: 'Plano',
    icon: iconMoney3,
    type: 'submenu',
    submenu: [
      {
        type: 'link',
        name: 'Meu plano',
        icon: null,
        url: companyAccount.plans,
        selected: [companyAccount.plans],
      },
      {
        type: 'link',
        name: 'Saldo e extrato',
        icon: null,
        url: companyAccount.viewBalance,
        selected: [companyAccount.viewBalance],
      },
      {
        type: 'link',
        name: 'Recarga simples',
        icon: null,
        url: companyAccount.recharge,
        selected: [companyAccount.recharge],
      },
      {
        type: 'link',
        name: 'Recarga automática',
        icon: null,
        url: companyAccount.rechargeAutomatic,
        selected: [companyAccount.rechargeAutomatic],
      },
      {
        type: 'link',
        name: 'Dados de faturamento',
        icon: null,
        url: companyAccount.editBilling,
        selected: [companyAccount.editBilling],
      }
    ],
  }],
}

export const supportMenu = {
}

export default {
  userMenu,
  companyMenu,
}